import { render } from "./FaqsRight.vue?vue&type=template&id=a8de8cec"
import script from "./FaqsRight.vue?vue&type=script&lang=js"
export * from "./FaqsRight.vue?vue&type=script&lang=js"

import "./FaqsRight.vue?vue&type=style&index=0&id=a8de8cec&lang=less"

import exportComponent from "D:\\wwwroot\\tutoredin\\online-education\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__